import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, IonFooter, useIonViewWillEnter, IonSlides, IonSlide } from '@ionic/react'
import { MktAmountBoard, SendInfoModal, PayModal, CardEquityModal } from '@cps'
import { cloneDeep } from '@dt/fe-utils/dist/lodash'
import { toast, useHistoryNew, modalLayer } from '@utils'
import { format, toPrice, toPriceNoCurrency } from '@dt/fe-utils'
import { Icon } from 'components'
import { giftCardMobx, memberMobx } from '@mobxStore'
import { useGiftCardDecorationInit, useGiftCardPageTitle } from '@common/hooks'
import { TermsTick, ChooseStore, BackHeader, CardShape, StoreListModal, CardBuyItem } from 'pages/mkt/components'
import BuyTypeModal from '../components/BuyTypeModal'
import i18n from 'i18next'
import './index.scss'

import archedBorImg from '@img/mkt/giftcard/arched-border.png'
import flowerBorImg from '@img/mkt/giftcard/flower-border.png'
import rectangleBorImg from '@img/mkt/giftcard/rectangle-border.png'
import squareBorImg from '@img/mkt/giftcard/square-border.png'
import handTopImg from '@img/mkt/giftcard/hand-top.png'
import handBottomImg from '@img/mkt/giftcard/hand-bottom.png'

interface IProps extends IPage, RouteComponentProps { }

const RechargeTypeOff = 'discountFee'
const PerMaxCount = 99

let startClientX: number = 0

const Detail: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { cardId } = match.params as any
  const { getEGiftCard } = giftCardMobx
  const { brandConfig } = memberMobx
  // Component State
  const [detailInfo, setDetailInfo] = useState<any>(null)
  const [showAmountModal, setShowAmountModal] = useState<boolean>(false)
  const [coverIndex, setCoverIndex] = useState<number>(0)
  const [shapeType, setShapeType] = useState<string>('rectangle')
  const [isAgree, setIsAgree] = useState<boolean>(false)
  const [showTip, setShowTip] = useState<boolean>(false)
  const [isShow, setIsShow] = useState<boolean>(true)
  const [cardShow, setCardShow] = useState<boolean>(false)
  const [clause, setClause] = useState<IClauseInfo>(null)
  const [storeInfo, setStoreInfo] = useState<IStoreInfo>({ storeId: 0, storeName: '' })
  const [cardMaps, setCardMaps] = useState({}) // 将要购买的卡信息
  const shapeImg = { rectangle: rectangleBorImg, flower: flowerBorImg, square: squareBorImg, arched: archedBorImg }
  const initOpts = {
    initialSlide: 0,
    autoplay: false,
    loop: false,
    on: {
      slideChange () {
        const swiper = this as any
        if (detailInfo && detailInfo.covers.length) {
          setCoverIndex(swiper.activeIndex)
        }
      }
    }
  }
  // Component Event
  const changeCustom = (val: number) => {
    setShowAmountModal(false)
    setCardMaps({
      ...cardMaps,
      0: { cardRechargeId: '0', recharge: val, give: 0, count: 1 }
    })
  }
  const changeTermsStatus = (status: boolean) => {
    if (status) setShowTip(false)
    setIsAgree(status)
  }
  const checkRule = () => {
    if (brandConfig.giftcardCzSetting && !brandConfig.giftcardCzSetting.channels.includes('mobile')) {
      toast({ message: i18n.t('mkt.member.notBuyTip') })
      return false
    }
    if (!isAgree && clause?.clauseName) {
      setShowTip(true)
      return false
    }
    return true
  }
  const handlePreBuy = () => {
    if (detailInfo.status === 'disable') {
      toast({ message: i18n.t('mkt.giftCard.gcDisableTip') })
      return
    }
    if (brandConfig?.isSelectStoreWhenCz && !storeInfo.storeId) {
      modalLayer(StoreListModal, { showIds: detailInfo?.isAllStore ? null : detailInfo.storeIds }, 'StoreListModal').then((val: any) => {
        setStoreInfo({ storeId: val.storeId, storeName: val.storeName })
        handlePreBuyType(Object.values(cardMaps).map((item: any) => ({
          recharge: item.recharge,
          give: item.give,
          count: item.count,
          cardRechargeId: item.cardRechargeId,
          storeId: val.storeId
        })))
      }).catch(() => { })
    } else {
      handlePreBuyType(Object.values(cardMaps).map((item: any) => ({
        recharge: item.recharge,
        give: item.give,
        count: item.count,
        cardRechargeId: item.cardRechargeId,
        storeId: brandConfig?.isSelectStoreWhenCz ? storeInfo.storeId : 0
      })))
    }
  }
  const handlePreBuyType = (cardsInfo: any) => {
    modalLayer(BuyTypeModal, null, 'buyTypeModal').then((val: any) => {
      if (val === 1 || val === 2) {
        if (memberMobx.isLogin) {
          handleBuy(cardsInfo, {
            email: '',
            message: '',
            givePerson: '',
            receivedPerson: ''
          }, val)
        } else {
          history.push('/login')
        }
      } else {
        modalLayer(SendInfoModal, { type: 'email', title: i18n.t('mkt.giftCard.tipBuyInfo'), sendInfo: { img: detailInfo.covers[coverIndex].url, shape: shapeType } }, 'sendInfoModal').then((val: any) => {
          handleBuy(cardsInfo, {
            email: val.user,
            message: val.message,
            givePerson: val.givePerson,
            receivedPerson: val.receivedPerson,
          })
        })
      }
    })
  }
  const handleScroll = (e: any) => {
    setTimeout(() => {
      if (e.detail.scrollTop >= 50) {
        setIsShow(false)
      } else {
        setIsShow(true)
      }
    }, 10)
  }
  let posting = false
  const handleBuy = async (cardsInfo: any, buyerInfo: any, isBind: number = 0) => {
    const orderList: any = []
    const orderParams: any = {
      eatType: 'giftcard',
      details: orderList,
      contactInfo: JSON.stringify(buyerInfo),
      totalFee: 0,
      paidFee: 0,
    }
    cardsInfo.forEach((cardInfo: any) => {
      orderList.push({
        type: 'giftcard',
        cnt: cardInfo.count,
        productCategoryNo: 'giftCardBuy',
        productName: detailInfo.giftcardName,
        productNo: cardId,
        productScaleNo: cardInfo.cardRechargeId ? `${cardInfo.cardRechargeId}` : '0',
        productExt: JSON.stringify({
          cover: detailInfo.covers[coverIndex].url,
          reloadType: detailInfo.reloadType,
          isBind: isBind ? 1 : 0,
          shape: shapeType
        }),
        paidFee: cardInfo.count * (cardInfo.recharge * 100) / 100,
        originalFee: cardInfo.count * (cardInfo.recharge * 100) / 100,
      })
      orderParams.totalFee = (orderParams.totalFee * 100 + cardInfo.count * (cardInfo.recharge * 100)) / 100
      orderParams.paidFee = (orderParams.paidFee * 100 + cardInfo.count * (cardInfo.recharge * 100)) / 100
    })
    orderParams.storeId = cardsInfo[0].storeId
    const checkInfo = await getEGiftCard(parseInt(cardId))
    if (detailInfo.sysModifyTime !== checkInfo.sysModifyTime) {
      toast({ message: i18n.t('mkt.giftCard.tipBuyInfoModify') })
      return
    }
    if (posting) return
    posting = true
    modalLayer(PayModal, { scene: 'giftcard_buy', orderPara: orderParams, history, wxGive: isBind === 2 }).finally(() => {
      posting = false
    })
  }
  const onTouchMove = (e: any) => {
    e.stopPropagation()
    const moveClientX: number = e.changedTouches[0].clientX
    if (startClientX && moveClientX - startClientX > 30) {
      changeCard('prev')
      startClientX = 0
    } else if (startClientX && startClientX - moveClientX > 30) {
      changeCard('next')
      startClientX = 0
    }
  }
  const changeCard = (key: string) => {
    const slidesTag = (document.getElementById('slidesTag') as any)
    if (key === 'prev' && coverIndex !== 0) {
      // setCoverIndex(coverIndex - 1)
      slidesTag.slidePrev()
    }
    if (key === 'next' && coverIndex !== detailInfo.covers.length - 1) {
      // setCoverIndex(coverIndex + 1)
      slidesTag.slideNext()
    }
  }
  const showCardEquity = (type: 'store' | 'gcDetail') => {
    modalLayer(CardEquityModal, { cardInfo: { card: detailInfo }, type }).then(() => { }, () => { })
  }
  // 添加卡
  const handleAddCard = card => () => {
    if (!checkRule()) return
    if (!cardMaps[card.id]) {
      setCardMaps({
        ...cardMaps,
        [card.id]: {
          recharge: card.recharge,
          give: card.give,
          count: 1,
          cardRechargeId: card.id
        }
      })
    }
  }
  // 修改卡数量
  const handleCardNum = (id: string, type: string) => (e: React.MouseEvent) => {
    e.stopPropagation()
    if (type === 'add' && cardMaps[id].count >= PerMaxCount) {
      return
    }
    const newCardMaps = cloneDeep(cardMaps)
    newCardMaps[id].count = type === 'add' ? newCardMaps[id].count + 1 : newCardMaps[id].count - 1
    if (newCardMaps[id].count === 0) {
      delete newCardMaps[id]
    }
    setCardMaps(newCardMaps)
  }
  // Component Effect
  useIonViewWillEnter(() => {
    getEGiftCard(parseInt(cardId)).then((res: any) => {
      setDetailInfo(res)
      setShapeType(res.covers[0]?.shapes ? res.covers[0].shapes[0] : 'rectangle')
      setTimeout(() => {
        setCardShow(true)
      }, 1500)
    })
  })
  useGiftCardDecorationInit()
  useGiftCardPageTitle()
  useEffect(() => {
    if (brandConfig?.clauses?.giftcard?.status === 'enable') {
      setClause(brandConfig.clauses.giftcard)
      setIsAgree(brandConfig.clauses.giftcard.isDefaultCheck)
    }
  }, [brandConfig])
  useEffect(() => {
    if (detailInfo && detailInfo.covers.length) {
      const shapeList = detailInfo.covers[coverIndex]?.shapes || []
      if (shapeList.length) {
        if (!shapeList.includes(shapeType)) {
          setShapeType(shapeList[0])
        }
      } else {
        setShapeType('rectangle')
      }
    }
  }, [coverIndex])

  const hasSelectAmounts = Object.keys(cardMaps).length > 0
  const payAmount: any = Object.values(cardMaps).reduce((prev: number, card: any) => (prev * 100 + card.count * (card.recharge * 100)) / 100, 0)
  return (
    <IonPage
      className={`giftcard-buy-page${hasSelectAmounts ? ' giftcard-buy-page-ano' : ''}`}
    >
      <BackHeader
        isShow={isShow}
        title={`${i18n.t('mkt.giftCard.topCardTit')}
        ${brandConfig?.isSelectStoreWhenCz ? '' : `(${i18n.t('mkt.member.rechargeOnline')})`}`}
      />
      <IonContent className='page-content' scrollEvents onIonScroll={handleScroll}>
        {
          detailInfo &&
            <>
              <div className='card-face-choose'>
                <div className='card-title'>{detailInfo.giftcardName}</div>
                <div className='card-face'>
                  <IonSlides className='card-slides' options={initOpts} key={detailInfo.giftcardId} id='slidesTag'>
                    {
                      detailInfo.covers.map((item: any, index: number) => {
                        return (
                          <IonSlide key={index + '_' + item.url}>
                            {
                              index === 0 && cardShow &&
                                <div className='hand-top-move' style={{ backgroundImage: `url(${handTopImg})` }}></div>
                            }
                            <div className={`card-area${shapeType === 'rectangle' ? ' card-area-rectangle' : ''}`}>
                              {(cardShow || index > 0) && <CardShape cardFace={item.url} border='none' shape={shapeType}></CardShape>}
                            </div>
                            {
                              index === 0 && cardShow &&
                                <div className='hand-bottom-move' style={{ backgroundImage: `url(${handBottomImg})` }}></div>
                            }
                          </IonSlide>)
                      })
                    }
                  </IonSlides>
                  {cardShow && <div className={`card-face-border${shapeType === 'rectangle' ? ' face-border-rectangle' : ''}`} style={{ backgroundImage: `url(${shapeImg[shapeType]})` }} onTouchStart={(e) => { startClientX = e.touches[0].clientX }} onTouchMove={onTouchMove}></div>}
                  {
                    detailInfo.covers[coverIndex].url &&
                      <div className='hand-move'>
                        <div className='hand-top-move' style={{ backgroundImage: `url(${handTopImg})` }}></div>
                        <div className={`card-move${shapeType === 'rectangle' ? ' card-move-rectangle' : ''}`}>
                          <CardShape cardFace={detailInfo.covers[coverIndex].url} border='border' shape={shapeType} isScale={false}></CardShape>
                        </div>
                        <div className='hand-bottom-move' style={{ backgroundImage: `url(${handBottomImg})` }}></div>
                      </div>
                  }
                </div>
                <div className='card-shape'>
                  {
                    detailInfo.covers[coverIndex]?.shapes && detailInfo.covers[coverIndex].shapes.length > 1 && detailInfo.covers[coverIndex].shapes.map((item: string) => (
                      <div data-cypid='mmgChangeCoverShape' className={`card-shape-content${shapeType === item ? ' card-shape-content-ed' : ''}`} key={item} onClick={() => setShapeType(item)}>
                        <div className={`card-shape-block${item === 'rectangle' ? ' card-shape-rectangle' : ''}`}>
                          <CardShape cardFace={detailInfo.covers[coverIndex].url} border='none' shape={item}></CardShape>
                        </div>
                        {shapeType === item && <div className='card-shape-checked'><i className='iconfont icon-check'></i></div>}
                      </div>
                    ))
                  }
                </div>
              </div>
              <div className='card-recharge'>
                <div className='card-recharge-title'>{i18n.t('mkt.giftCard.chooseAmount')}</div>
                <div className='card-recharge-block'>
                  {
                  detailInfo?.reloadAmounts.map((item: any, index: number) => (
                    <div data-cypid='mmgAddGCard' className='recharge-info-block' key={index} onClick={handleAddCard(item)}>
                      <CardBuyItem color='grey' isRecommend={!!item?.ifRecommend}>
                        <div className='recharge-info-price'>{toPrice(item.recharge)}</div>
                        {item.give > 0 && (
                          <div className={`recharge-info-des ${detailInfo.reloadType === RechargeTypeOff ? 'origin-price' : ''}`}>
                            {detailInfo.reloadType === RechargeTypeOff
                              ? `${i18n.t('mkt.giftCard.originPrice')}${toPrice(item.recharge + item.give)}`
                              : `${i18n.t('mkt.giftCard.giveAway')} ${toPrice(item.give)}`}
                          </div>
                        )}
                        {cardMaps[item.id] && (
                          <div className='recharge-price-mask'>
                            <div className='recharge-price-mask-num'>
                              <Icon data-cypid='mmgAddGCardNum' name='minus-circle' className='recharge-price-mask-icon' onClick={handleCardNum(item.id, 'sub')} />
                              <div className='recharge-price-mask-num-value'>{cardMaps[item.id].count}</div>
                              <Icon
                                data-cypid='mmgSubGCardNum'
                                name='add-circle'
                                className={`recharge-price-mask-icon${cardMaps[item.id].count >= PerMaxCount ? ' recharge-price-mask-icon-disabled' : ''}`}
                                onClick={handleCardNum(item.id, 'add')}
                              />
                            </div>
                          </div>
                        )}
                      </CardBuyItem>
                    </div>
                  ))
                  }
                  {
                  detailInfo?.allowCustomizeLoad &&
                    <div
                      className='recharge-info-block'
                      data-cypid='mmgCustomReloadGCard'
                      onClick={() => {
                        if (detailInfo.status === 'disable') {
                          toast({ message: i18n.t('mkt.giftCard.gcDisableTip') })
                          return
                        }
                        if (!checkRule()) return
                        if (brandConfig?.isSelectStoreWhenCz && !storeInfo.storeId) {
                          modalLayer(StoreListModal, { showIds: detailInfo?.isAllStore ? null : detailInfo.storeIds }, 'StoreListModal').then((val: any) => {
                            setStoreInfo({ storeId: val.storeId, storeName: val.storeName })
                            setShowAmountModal(true)
                          }).catch(() => { })
                        } else {
                          setShowAmountModal(true)
                        }
                      }}
                    >
                      <CardBuyItem color='grey'>
                        <div className='recharge-custom-price'>{i18n.t('newCart.auto')}</div>
                        <div className='recharge-custom-des'>{`${i18n.t('mkt.giftCard.maxLoad', { amount: format.toPriceNoCurrency(detailInfo.maxLoad, -1) })}, ${i18n.t('mkt.giftCard.minLoad', { amount: format.toPriceNoCurrency(detailInfo.minLoad, -1) })}`}</div>
                      </CardBuyItem>
                      {cardMaps[0] && (
                        <div className='recharge-price-mask'>
                          <div className='recharge-price-mask-amount'>
                            <span>{format.toCurrency()}</span>
                            {toPriceNoCurrency(cardMaps[0].recharge)}
                          </div>
                          <div className='recharge-price-mask-num'>
                            <Icon data-cypid='mmgAddGCardNum' name='minus-circle' className='recharge-price-mask-icon' onClick={handleCardNum('0', 'sub')} />
                            <div className='recharge-price-mask-num-value'>{cardMaps[0].count}</div>
                            <Icon
                              data-cypid='mmgSubGCardNum'
                              name='add-circle'
                              className={`recharge-price-mask-icon${cardMaps[0].count >= PerMaxCount ? ' recharge-price-mask-icon-disabled' : ''}`}
                              onClick={handleCardNum('0', 'add')}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  }
                </div>
                <div className='card-detail-enter-block'>
                  {detailInfo.description && (
                    <div data-cypid='mmgToGCardDetail' className='enter-item' onClick={() => showCardEquity('gcDetail')}>
                      <span>{i18n.t('mkt.member.useRule')}</span>
                      <i className='iconfont icon-chevron-right'></i>
                    </div>
                  )}
                  <div data-cypid='mmgToGCardStores' className='enter-item' onClick={() => showCardEquity('store')}>
                    <span>{i18n.t('mkt.member.applyStore')}</span>
                    <i className='iconfont icon-chevron-right'></i>
                  </div>
                </div>
              </div>
            </>
        }
      </IonContent>
      {hasSelectAmounts ? (
        <div className='card-pay'>
          <div data-cypid='mmgPreBuyGCard' className='card-pay-btn' onClick={handlePreBuy}>
            <div className='card-pay-btn-text'>
              {i18n.t('mkt.giftCard.confirmPay')}
              <span className='card-pay-btn-unit'>{format.toCurrency()}&nbsp;</span>
              <span className='card-pay-btn-num'>{toPriceNoCurrency(payAmount)}</span>
            </div>
          </div>
        </div>
      ) : (
        <IonFooter className='page-footer'>
          {
            clause?.clauseName && <div className='amount-title'><TermsTick terms={clause} isCheck={isAgree} showTip={showTip} onChange={(check: boolean) => changeTermsStatus(check)} /></div>
          }
          {
            detailInfo &&
              <div className='card-choose'>
                {/* <div onClick={() => modalLayer(GiftCardDetailModal, { eGiftCardInfo: detailInfo }, 'giftCardDetailModal')}>{i18n.t('mkt.giftCard.giftcardDetails')}</div> */}
                <ChooseStore scene='giftCard' openChoose={!!brandConfig?.isSelectStoreWhenCz} detailInfo={detailInfo} storeInfo={storeInfo} onChange={(info: any) => setStoreInfo(info)}></ChooseStore>
              </div>
          }
        </IonFooter>
      )}
      {/* 自定义金额 */}
      <MktAmountBoard
        visible={showAmountModal}
        min={detailInfo && detailInfo.minLoad}
        max={detailInfo && detailInfo.maxLoad}
        onClose={() => setShowAmountModal(false)}
        onSave={(val: number) => changeCustom(val)}
      >
      </MktAmountBoard>
    </IonPage>
  )
}

export default observer(Detail)
